import React from "react";
 
function About () {
    return (
    <div class="container">
        <div class="about row">
            <div class="about card col-md-8 justify-content-center">
                <h1>Hello and welcome! 👋</h1>
                <h2>I’m John Ho, a UI UX researcher in Washington fueled by curiosity. I love designing cool projects, and love talking to people even more! :D</h2>
                <p>With a B.Sc. in Informatics focused on Human-Computer Interaction, I explore design and research processes to put into my projects and works. I have rich experience conducting user research, creating design systems, and bridging design to developers in apps and design solutions.</p>
                <p>With my love of the Internet and technology, I am inspired to promote well-being within information systems and create quality of life changes for all.</p>
            </div>
            <div class="about card col-md-4 justify-content-center">
                <img src="img/JDH1.png" alt='Portrait'></img>
            </div>
        </div>
        <div class="about row">
            <div class="about card col-md-6 justify-content-center">
                <img src="img/JDH2.png" alt='Portrait'></img>
            </div>
            <div class="about card col-md-6 text-center justify-content-center">
                <h1>✨ My Skills ✨</h1>
                <h2>📝 UX Research 📝</h2>
                <h2>💡 User Testing 💡</h2>
                <h2>🎨 Design Systems 🎨</h2>
                <h2>🔧 Wireframes and Prototypes 🔧</h2>
                <h2>🌐 Web and UI Design 🌐</h2>
            </div>
        </div>
        <div class='about row'>
            <div class="about card col-md-8 justify-content-center">
            <p>With a background in performing music and visual arts before university, I have been interested in the complexity of human emotions and communication through art. I love drawing, music, and psychology, which lead to my passion in the UI and UX fields.</p>
            <p>I also adore video games, cooking, and diving into Internet subcultures. In my free time, I read books and manga, walk my two dogs, and learn new recipes in the kitchen — all while listening to music.</p>
            </div>
            <div class="about card col-md-4 justify-content-center">
                <img src="img/JDH3.png" alt='Portrait'></img>
            </div>
        </div>
    </div>
    
    );
};
 
export default About;